import { render, staticRenderFns } from "./ZotReferenceLink.vue?vue&type=template&id=fd08cc66&"
import script from "./ZotReferenceLink.vue?vue&type=script&lang=js&"
export * from "./ZotReferenceLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports